/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/11/2022
 */

import React from "react";
import { Checkbox, FormControl, FormControlLabel, Stack } from "@mui/material";
import { UseFormReturnType } from "@mantine/form";
import { SummaryNotificationConfig } from "../../interfaces/Global";
import EventTypeControl from "../../controls/EventTypeControl";

export interface ConfigContentProps {
	form: UseFormReturnType<SummaryNotificationConfig>;
}

export default function ConfigContent({ form }: ConfigContentProps) {

	return (
		<Stack spacing={1} mb={2}>
			<FormControl variant={"standard"}>
				<FormControlLabel
					control={
						<Checkbox
							{...form.getInputProps("includeUnavailable", { type: "checkbox" })}
						/>
					}
					label={"Include Unavailable Employees"}
				/>
			</FormControl>
			<FormControl variant={"standard"}>
				<FormControlLabel
					control={
						<Checkbox
							{...form.getInputProps("includeAvailable", { type: "checkbox" })}
						/>
					}
					label={"Include Available Employees"}
				/>
			</FormControl>
			<FormControl variant={"standard"}>
				<FormControlLabel
					control={
						<Checkbox
							{...form.getInputProps("includeEventCategories", { type: "checkbox" })}
						/>
					}
					label={"Include Event Categories"}
				/>
			</FormControl>
			{form.values.includeEventCategories &&
				<EventTypeControl
					label={"Event Categories"}
					showTypes={false}
					showCategories={true}
					values={form.values.eventCategories}
					onChange={(values) => form.setFieldValue('eventCategories', values)}
				/>}
			<FormControl variant={"standard"}>
				<FormControlLabel
					control={
						<Checkbox
							{...form.getInputProps("includeEventTypes", { type: "checkbox" })}
						/>
					}
					label={"Include Event Types"}
				/>
			</FormControl>
			{form.values.includeEventTypes &&
				<EventTypeControl
					label={"Event Types"}
					showTypes={true}
					showCategories={false}
					values={form.values.eventTypes}
					onChange={(values) => form.setFieldValue('eventTypes', values)}
				/>}
			<FormControl variant={"standard"}>
				<FormControlLabel
					control={
						<Checkbox
							{...form.getInputProps("includeBirthdays", { type: "checkbox" })}
						/>
					}
					label={"Include Birthdays"}
				/>
			</FormControl>
			<FormControl variant={"standard"}>
				<FormControlLabel
					control={
						<Checkbox
							{...form.getInputProps("includeAnniversaries", { type: "checkbox" })}
						/>
					}
					label={"Include Anniversaries"}
				/>
			</FormControl>
		</Stack>
	);

}